import { AxiosResponse } from 'axios';
import { useAxios } from '@/features/common/helpers/axios';
import { CutoffTimesResponse } from '@/features/cutoff-times/types';

const { axiosService } = useAxios();

export const getCutoffTimes = async (
  countryCode: string,
  postalCode: string,
): Promise<CutoffTimesResponse> => {
  try {
    const response: AxiosResponse = await axiosService.get(
      `carriers/cutoff-times/${countryCode}/${postalCode}`,
    );

    return response.data;
  } catch {
    return [];
  }
};
